// eslint-disable-next-line
import { injectable } from "inversify";
import { TYPE, rootContainer } from '../container/root';
import { IApiResponse, IHttpService } from "../http-service";
import { IFetchListArgs, IPagedData } from '../../stores/abstract-paged-data-store';
import { createPagedRequestURLSearchParams } from '../helpers';

export interface ICredit {
    id: number;
    store_customer_id: number;
    customer_id?: number;
    user_id: number;
    discount_code: string;
    credits?: number;
    credits_formatted: string;
    gift_card_credits?: number;
    gift_card_credits_formatted: string;
    created_at: string;
    updated_at: string;
    deleted_at?: string;
    admin_customer_url: string;
    admin_discounts_url: string;
}

export interface IFetchCreditListArgs extends IFetchListArgs {
    search_customer_id: string;
}

@injectable()
class CreditsService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    async fetchList(args: IFetchCreditListArgs): Promise<IPagedData<ICredit>> {
        const { page, perPage, sortBy, sortDir, search_customer_id } = args;
        const searchParams = createPagedRequestURLSearchParams(page, perPage, sortBy, sortDir);

        if (search_customer_id) {
            searchParams.append('search_customer_id', search_customer_id);
        }

        const res = await this.httpService.get<IApiResponse<IPagedData<ICredit>>>(`/rms-api/credits?${searchParams.toString()}`);
        return res.payload;
    }

    async adjustBalance(id: number, transaction_type_id: number, amount: number, comment: string) {
        const data = {
            transaction_type_id,
            amount,
            comment
        }
        const res = await this.httpService.post<IApiResponse<ICredit>>(`/rms-api/credits/${id}/adjust`, data);
        return res.payload;
    }
}

export default CreditsService;
